module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/sitONS/tc-custom/9781913682408.jpg?1704717799692",
      "alt": "This image is the cover for the book Murder by the Broads"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Murder by the Broads\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("Murder rocks an English seaside town, and a police detective must put the pieces together in this tense crime thriller.")]), _c('br'), _c('br'), _vm._v(" DS Adam Burnt has been called to a crime scene where a young man lies stabbed to death amid signs of a struggle—and not far away, another young man has been fatally hit by a truck. Using the corpse’s thumb to unlock his cellphone helps to ID the victim, but plenty of questions remain. The first suspicion is gang activity. But Burnt is also troubled by other suspicions—specifically, that his wife may be having an affair."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" As the clues unfold, DS Burnt begins a game of cat and mouse. What links the case to a doctor and a psychiatric hospital? Trying to juggle his personal life and the job, Burnt must navigate the seaside town of Great Yarmouth and the surrounding areas to catch a killer . . .\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Anthony Tamiozzo\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Bloodhound Books\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0